import { SearchResults } from "../SearchResults";
import { GlobalSearchResultsResponse } from "@kaltura/mediaspace-shared-types";
import { NoResults, SearchResultsDisplayComponentProps } from "@kaltura/mediaspace-shared-search";

/**
 * search result data for suspense below
 */
export function SearchResultsData({
    isSearch,
    isTextSearch,
    fetchModuleData,
    onEntryShowMore,
    page,
    onPageChange,
    pageSize,
    isWideLayout,
    searchInLabel,
}: SearchResultsDisplayComponentProps<GlobalSearchResultsResponse>) {
    const { data } = fetchModuleData();

    return (
        <>
            {data && (
                <SearchResults
                    {...data}
                    isTextSearch={isTextSearch}
                    page={page}
                    onPageChange={onPageChange}
                    pageSize={pageSize}
                    onEntryShowMore={onEntryShowMore}
                    isWideLayout={isWideLayout}
                    searchInLabel={searchInLabel}
                />
            )}
            {!data && isSearch && <NoResults screenMode="nomatches" />}
            {!data && !isSearch && <NoResults screenMode="nopublic" />}
        </>
    );
}
